module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp3_8017.a89d10df.png";